import styled from 'styled-components';

export const HubLiveContainer = styled.div`
  text-align: center;
  width: 100%;
  min-width: 270px;
  position: initial;
  min-height: 300px;
  background: ${props => props.theme.colors.mainColor};
`;
